import { navigate } from "gatsby";
import React from "react";

const Menu = () =>{
    return(
        <ul className="menu-list-pointer">
            <li onClick={()=>navigate('/dac-quyen.html')}>
                <div className="row mgx-0 in-f">
                    <div className="box-svg-menu in-f pdr-10">
                        <img src="../images/web_app/tk_dac_quyen.svg" alt="icon"/>
                    </div>
                    <div className="in-f">
                        <a href='/dac-quyen.html'><span>Đặc quyền thành viên</span></a>
                    </div>
                </div>
            </li>
            {/* <li onClick={()=>navigate('/account/service.html')}>
                <div className="row mgx-0 in-f">
                    <div className="box-svg-menu in-f pdr-10">
                        <img src="../images/web_app/tk_tien_ich_dich_vu.svg" alt="icon"/>
                    </div>
                    <div className="in-f">
                        <a href='/account/service.html'><span>Tiện ích, dịch vụ</span></a>
                    </div>
                </div>
            </li> */}
            <li onClick={()=>navigate('/account/orders.html')}>
                <div className="row mgx-0 in-f">
                    <div className="box-svg-menu in-f pdr-10">
                        <img src="../images/web_app/tk_don_hang_cua_ban.svg" alt="icon"/>
                    </div>
                    <div className="in-f">
                        <a href='/account/orders.html'><span>Đơn hàng</span></a>
                    </div>
                </div>
            </li>
            <li onClick={()=>navigate('/account/support.html')}>
                <div className="row mgx-0 in-f">
                    <div className="box-svg-menu in-f pdr-10">
                        <img src="../images/web_app/tk_ho_tro_nguoi_dung.svg" alt="icon"/>
                    </div>
                    <div className="in-f">
                        <a href='/account/support.html'><span>Hỗ trợ người dùng</span></a>
                    </div>
                </div>
                
            </li>
            <li onClick={()=>navigate('/account/manager.html')}>
                <div className="row mgx-0 in-f">
                    <div className="box-svg-menu in-f pdr-10">
                        <img src="../images/web_app/tk_user.svg" alt="icon"/>
                    </div>
                    <div className="in-f">
                        <a href='/account/manager.html'><span>Quản lý tài khoản</span></a>
                    </div>
                </div>
            </li>
            <li onClick={()=>navigate('/account/noti.html')}>
                <div className="row mgx-0 in-f">
                    <div className="box-svg-menu in-f pdr-10">
                        <img src="../images/web_app/tk_thong_bao_bai_viet.svg" alt="icon"/>
                    </div>
                    <div className="in-f">
                        <a href='/account/noti.html'><span>Thông báo, bài viết</span></a>
                    </div>
                </div>
            </li>
            <li onClick={()=>navigate('/account/police.html')}>
                <div className="row mgx-0 in-f">
                    <div className="box-svg-menu in-f pdr-10">
                        <img src="../images/web_app/tk_quy_dinh_chinh_sach.svg" alt="icon"/>
                    </div>
                    <div className="in-f">
                        <a href='/account/police.html'><span>Quy định, chính sách</span></a>
                    </div>
                </div>
            </li>
            <li onClick={()=>navigate('/account/about.html')}>
                <div className="row mgx-0 in-f">
                    <div className="box-svg-menu in-f pdr-10">
                        <img src="/images/account/Frame_766145.png" alt="icon"/>
                    </div>
                    <div className="in-f">
                        <a href='/account/about.html'><span>Về Bibo Mart</span></a>
                    </div>
                </div>
            </li>
        </ul>
    )
}

const Menu1 = () =>{
    return(
        <ul className="menu-list-pointer">
            <li onClick={()=>navigate('/dac-quyen.html')}>
                <a href='/dac-quyen.html'><span>Đặc quyền thành viên</span></a>
            </li>
            {/* <li onClick={()=>navigate('/account/service.html')}>
                <a href='/account/service.html'><span>Tiện ích, dịch vụ</span></a>
            </li> */}
            <li onClick={()=>navigate('/account/orders.html')}>
                <a href='/account/orders.html'><span>Đơn hàng</span></a>
            </li>
            <li onClick={()=>navigate('/account/support.html')}>
                <a href='/account/support.html'><span>Hỗ trợ người dùng</span></a>
                
            </li>
            <li onClick={()=>navigate('/account/manager.html')}>
                <a href='/account/manager.html'><span>Quản lý tài khoản</span></a>
            </li>
            <li onClick={()=>navigate('/account/noti.html')}>
                <a href='/account/noti.html'><span>Thông báo, bài viết</span></a>
            </li>
            <li onClick={()=>navigate('/account/police.html')}>
                <a href='/account/police.html'><span>Quy định, chính sách</span></a>
            </li>
            <li onClick={()=>navigate('/account/about.html')}>
                <a href='/account/about.html'><span>Về Bibo Mart</span></a>
            </li>
        </ul>
    )
}

export {Menu, Menu1} ;